import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid';
import { SkyLightStateless } from 'react-skylight';
import { Data, Toolbar } from 'react-data-grid-addons';
import { Breadcrumb, Button, ButtonToolbar, Col, Dropdown, Grid, MenuItem, Panel, Row } from 'react-bootstrap';
import _, { debounce, isEqual } from 'lodash';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../Common/constants';
import Spinner from '../../components/Widgets/spinner';
import { dateFormat, toFromDates } from '../Common/cleanDates';
import ConfirmActionModal from '../Common/confirmActionModal';
import CashFormatter from '../Common/cashFormatter';
import SpinnerButton from '../Common/SpinnerButton';
import {
  companyCodeTitle, isABBLE, isGGI, isOCM, isSH, isAP, ROOT_API_URL, ROOT_URL, isARC,
  isOLG, isVAK, isMH, isLAP, isAPD, isSV, isEKC, isLMH, isBRO, isSDR, isCRW, isCPG,
  isCCW, isVIP, isTQ, isUSPrideMulti, isGFD, isSC, isSW
} from '../../actions/root_url';
import checkPermission from '../Common/permissions';
import dateFilterRadios from '../Common/dateFilterRadios';
import WarehouseManagementModals from '../Common/modals/warehouseManagement';
import genericRadioFilter from '../Common/genericRadioFilter';
import { cashFormatter, getKeysMap, getSortVal } from '../../utils';
import { RECEIVE_HISTORY_SORT_KEY_OBJ } from '../../utils/map';

const {
  ReceivedPOMergeModal,
  ReceivedPOSplitModal,
} = WarehouseManagementModals;

const isRivera = (ROOT_API_URL === 'https://rivera-scm.truckxi.com/api/') || (ROOT_API_URL === 'https://rvrstage-scm.truckxi.com/api/');
const isTN = ROOT_API_URL === 'https://tn-scm.truckxi.com/api/' || ROOT_URL === 'https://tn-scm.truckxi.com/api/';
const isUSPride = ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || ROOT_URL === 'https://uspride-scm.truckxi.com/api/';

const API_FILTERABLE_COLUMNS = [
  'PONum', 'WarehouseReceiveNum', 'InvoiceNum', 'VendorName'
]
const finalizeReceiveValidation = (rows) => {
  let isValid = true;
  rows.forEach(r => {
    if (r.InvoiceStatus === 'FINALIZED') {
      isValid = false;
    }
  })
  return isValid;
}

class ReceiveHistoryList extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton,

      createOpen: false,
      editRecPermissionOpen: false,
      statusOpen: false,
      case: null,

      syncModalVisibility: false,
      syncMsg: '',

      rows: [],
      selectedRows: [],
      editedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      gourpOpen: false,

      receiveHistoryLine: {
        rows: [],
        selectedRows: null,
        editedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        gourpOpen: false,
      },

      PdfFrameLoaded: true,
      Days: '7',
      FromDate: undefined,
      ToDate: undefined,

      WarehouseReceive_id: null,
      isFinalizeConfirmationModalVisible: false,
      isReceivedPOMergeModalVisible: false,
      isReceivedPOSplitModalVisible: false,

      Type: null,
      PaymentStatus: null,
      currentPage: 0,
      limit: (isSH || isAP) ? 10 : 30,
      limitDisplay: (isSH || isAP) ? '10' : '30',
      apiSortInfo: {
        sortColumn: null,
        sortDirection: null,
      },
    };

    this.handleResize = this.handleResize.bind(this);

    this.openCreate = this.openCreate.bind(this);
    this.closeCreate = this.closeCreate.bind(this);
    this.receiveDetail = this.receiveDetail.bind(this);
    this.autoPutaway = this.autoPutaway.bind(this);
    this.closeSyncVisibility = this.closeSyncVisibility.bind(this);

    this.reactDataGridRef = null;
  }

  componentWillMount() {
    this.props.setDefaultOfForm('Days', '7', 'receiveHistoryList');
    // this.props.fetchReceiveHistoryByDate(0, 0, '7');
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    if (isOCM || isSH || isAP) {
      this.state.currentPage = this.props.currentPage;
      // const {selectedRows} = this.props;
      // if (!isEqual(selectedRows, this.state.selectedRows)) {
      //   this.setState({selectedRows: selectedRows})
      // }
    }
    this.props.fetchReceiveHistoryByDate(0, 0, '7', false, this.state.Type, this.state.currentPage, this.state.limit, this.state.PaymentStatus, this.getFilterParams());
  }

  // Once purchaseOrders is ready, reset state.
  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedWarehouse !== this.props.selectedWarehouse) {
      this.refreshList();
    }
    if (nextProps.passcodeVerified && !this.props.passcodeVerified) {
      this.props.setPasscodeVerificationStatus();
      this.receiveDetailRedirect();
    }
    if (nextProps.FromDate && nextProps.FromDate !== this.props.FromDate) {
      this.setState({ fromDate: nextProps.FromDate }, this.fetchReceiveHistoryByDetails);
    }
    if (nextProps.ToDate && nextProps.ToDate !== this.props.ToDate) {
      this.setState({ toDate: nextProps.ToDate }, this.fetchReceiveHistoryByDetails);
    }
    if (nextProps.currentReceiveHistoryDetail && nextProps.currentReceiveHistoryDetail != this.props.currentReceiveHistoryDetail) {
      if (nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed) {
        const newRows = [...nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line_Completed];
        newRows.map((newRow) => {
          newRow.RcvUnitPrice = newRow.RcvUnitPrice ? newRow.RcvUnitPrice : newRow.FOBUnitPrice;
        });
        const receiveHistoryLine = { ...this.state.receiveHistoryLine, rows: newRows };
        this.setState({ receiveHistoryLine });
      } else {
        const receiveHistoryLine = { ...this.state.receiveHistoryLine, rows: nextProps.currentReceiveHistoryDetail.Warehouse_Receive_Line };
        this.setState({ receiveHistoryLine });
      }
    }
    if (nextProps.checkPermissionSuccess && nextProps.checkPermissionSuccess !== this.props.checkPermissionSuccess) {
      if (nextProps.checkPermissionSuccess.manager) {
        this.closeEditRecPermission();
        this.setState({ editRecPermission: true });
        this.props.voidReceiving(this.state.selectedRows[0].WarehouseReceive_id);
      }
    }

    if (nextProps.voidStatus) {
      this.openStatusModal();
    }

    if (nextProps.currentReceiveHistory && nextProps.currentReceiveHistory !== this.props.currentReceiveHistory) {
      let receives = nextProps.currentReceiveHistory.Invoices;

      // filter out purchase returns from warehouse receiving list
      receives = _.filter(
        receives,
        receive => (receive.PurchaseReturn_id === undefined),
      );
      //
      // receives.map((receive) => {
      //   receive.VendorName = receive.Purchase.Vendor.Name;
      //   receive.FinalPrice = receive.Purchase.FinalPrice;
      //   receive.TotalPrice = receive.Purchase.TotalPrice;
      // });
      this.setState({
        selectedRows: [],
      });
      if (isOCM) {
        // const warehouseReceiveIds = this.state.selectedRows.map(item => item.WarehouseReceive_id)
        // const newRows = receives.map(item => {
        //   return {
        //     ...item,
        //     isSelected: !!warehouseReceiveIds.includes(item.WarehouseReceive_id)
        //   }
        // })
        this.setState({rows: receives});
        // const scrollTopPositionIndex = this.props.scrollTopPositionIndex;
        // if (scrollTopPositionIndex !== null) {
        //   const top = 25 * scrollTopPositionIndex;
        //   if (this.reactDataGridRef) {
        //     var gridCanvas = this.reactDataGridRef
        //       .getDataGridDOMNode()
        //       .querySelector(".react-grid-Canvas");
        //     gridCanvas.scrollTop = top;
        //   }
        // }
      } else {
        this.setState({
          rows: receives,
        });
      }
    }

    if (nextProps.warehouseReceivePdf && nextProps.warehouseReceivePdf !== this.props.warehouseReceivePdf) {
      this.setState({ PdfFrameLoaded: false });
    }
    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      if (nextProps.Days !== '-1') {
        this.props.setDefaultOfForm('FromDate', null, 'receiveHistoryList');
        this.props.setDefaultOfForm('ToDate', null, 'receiveHistoryList');
      }
    }

    if ((typeof (this.props.FromDate) !== 'undefined') && (typeof (this.props.ToDate) !== 'undefined') && ((nextProps.FromDate !== this.props.FromDate) || (nextProps.ToDate !== this.props.ToDate))) {
      let dateRange = -1;
      let FromDate = '1900-01-01';
      let ToDate = '3000-01-01';
      if (nextProps.FromDate != null) { FromDate = this.formatDate(nextProps.FromDate); }

      if (nextProps.ToDate != null) { ToDate = this.formatDate(nextProps.ToDate); }

      if (this.props.Days != null) { dateRange = this.props.Days; }
      if (this.props.voidStatus) { this.props.resetDeleteStatus(); }
      this.resetFilters();
      this.props.fetchReceiveHistoryByDate(FromDate, ToDate, dateRange, false, this.state.Type, this.state.currentPage, this.state.limit, this.state.PaymentStatus, this.getFilterParams());
    }
    if (nextProps.currentPage && nextProps.currentPage !== this.props.currentPage) {
      this.setState({ currentPage: nextProps.currentPage });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && this.state.PdfFrameLoaded == false) {
      return false;
    }

    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    if ((isOCM || isSH || isAP) && prevState.currentPage !== prevProps.currentPage) {
      this.props.setPaginationFilters({currentPage: prevState.currentPage})
    }
    if (isOCM && !isEqual(this.props.selectedRows, this.state.selectedRows)) {
      this.props.setSelectedRows(this.state.selectedRows)
    }
  }

  refreshList = (clearSelectedRow = false) => {
    if (clearSelectedRow) {
      this.setState({ selectedRows: [] })
    }
    this.resetFilters();
    this.props.fetchReceiveHistoryByDate(this.state.FromDate, this.state.ToDate, this.state.Days, false, this.state.Type, this.state.currentPage, this.state.limit, this.state.PaymentStatus, this.getFilterParams())
  }

  resetFilters = () => {
    this.setState({ filters: {} })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  // Set purchaseOrders being selected to be currentReceive and navigate user to the edit page
  setCurrentReceive(e) {
    e.preventDefault();
    const currentReceive = this.state.selectedRows[0];
    this.props.selectReceive(currentReceive);
  }

  closeSyncVisibility() {
    this.setState({ syncModalVisibility: false });
  }

  openCreate() { this.setState({ createOpen: true }); }
  closeCreate() { this.setState({ createOpen: false }); }

  openStatusModal = () => {
    this.setState({ case: 'voidStatus', statusOpen: true });
  }

  closeStatusModal = () => {
    this.props.resetDeleteStatus();
    this.setState({ statusOpen: false }, this.fetchReceiveHistoryByDetails(this.props.Days));
  }

  openEditRecPermission = () => {
    this.setState({ case: 'editRecPermission', editRecPermissionOpen: true });
  }

  handleFinalizeConfirm = () => {
    const {
      selectedRows,
    } = this.state;
    const isValid = finalizeReceiveValidation(selectedRows);
    if (!isValid) {
      alert('Order has already been finalized');
      return;
    }
    const ids = selectedRows.map(row => row.WarehouseReceive_id);

    const success = () => {
      this.setFinalizeConfirmationModalVisibility();
      this.refreshList();
    }
    const failed = err => {
      this.setFinalizeConfirmationModalVisibility();
      alert(err ? err.data : 'failed');
    }
    this.props.finalizeReceive(ids.join(','), success, failed);
  }

  handleFinalizeClick = () => {
    this.setState({
      case: 'finalizeConfirm'
    }, () => {
      this.setFinalizeConfirmationModalVisibility(true);
    })
  }

  setFinalizeConfirmationModalVisibility = (isFinalizeConfirmationModalVisible = false) => this.setState({ isFinalizeConfirmationModalVisible });

  closeEditRecPermission = () => {
    this.setState({ editRecPermissionOpen: false });
  }

  receiveDetail(e) {
    e.preventDefault();
    if (isRivera) {
      this.props.setConfirmPasscodeModalVisibility(true);
      return;
    }
    this.receiveDetailRedirect();
  }

  receiveDetailRedirect = () => {
    const currentReceiveHistory = this.state.selectedRows[0];
    this.props.resetCurrentReceiveHistory();
    this.props.selectReceiveHistory(currentReceiveHistory);
    this.context.router.push(`/inventories/receiveHistory/${currentReceiveHistory.PONum}`);
  }

  autoPutaway(e) {
    e.preventDefault();
    const currentReceiveHistory = this.state.selectedRows;
    const receiveHistory = currentReceiveHistory.map(history => history.WarehouseReceive_id);
    this.props.autoPutaway(receiveHistory);
  }

  handleResize() {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton });
  }

  clickNew(e) {
    e.preventDefault();
    // this.props.resetCurrentReceive();
    this.context.router.push('/inventories/receive/new');
  }

  fetchReceiveHistoryByDetails = (days) => {
    if (days !== '-1') {
      this.setState(
        { FromDate: undefined, ToDate: undefined, Days: days },
        () => {
          this.resetFilters();
          this.props.fetchReceiveHistoryByDate(this.state.FromDate, this.state.ToDate, this.state.Days, false, this.state.Type, this.state.currentPage, this.state.limit, this.state.PaymentStatus, this.getFilterParams()); },
      );
    } else {
      this.setState(
        { Days: '-1' },
        () => {
          this.resetFilters();
          this.props.fetchReceiveHistoryByDate(this.state.FromDate, this.state.ToDate, this.state.Days, false, this.state.Type, this.state.currentPage, this.state.limit, this.state.PaymentStatus, this.getFilterParams()); },
      );
    }
  }

  formatDate(date) {
    return dateFormat('YYYY-MM-DD', date);
    /*
      let formattedDate = date.getFullYear() + '-';

      formattedDate += date.getMonth()+1 + '-';
      if (date.getDate() < 10) {
        formattedDate += '0' + date.getDate();
      } else {
        formattedDate += date.getDate();
      }

      return formattedDate;
    */
  }

  IFrameIsLoaded = () => {
    if (!this.state.PdfFrameLoaded) {
      const pdfFrame = window.frames.Pdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoaded: true });
    }
  }

  getFilterParams = () => {
    const {filters} = this.state;
    const filterParams = [];
    _.forOwn(filters, (value, key) => {
      filterParams.push([key, value.filterTerm])
    });
    const {sortColumn, sortDirection} = this.state.apiSortInfo;
    const result = Object.fromEntries(filterParams);
    if (isOCM && ['ASC', 'DESC'].includes(sortDirection)) {
      const key = getKeysMap(sortColumn, RECEIVE_HISTORY_SORT_KEY_OBJ);
      result.sort = getSortVal(key, sortDirection === "DESC");
    }
    return result;
  }


    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
    renderTable() {
      if (this.props.isLoading && !this.props.error && !isOCM) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the row select function
      const onRowSelect = (rows) => {
        this.setState(...this.state, { selectedRows: rows });
      };
      const onRowsSelected = (rows) => {
        this.props.setScrollTopPositionIndex(rows[0].rowIdx);
        const newRows = getRows();
        const selectedRows = [...this.state.selectedRows];
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
          selectedRows.push(r.row);
        });
        this.setState({
          rows: newRows,
          selectedRows,
        });
      };
      const onRowsDeselected = (rows) => {
        const newRows = [...this.state.rows];
        const selectedRows = [...this.state.selectedRows];
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
          const rowIndex = selectedRows.findIndex(item => item.WarehouseReceive_id === r.row.WarehouseReceive_id);
          selectedRows.splice(rowIndex, 1);
        });
        this.setState({
          rows: newRows,
          selectedRows,
        });
      };

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        if (isOCM) {
          this.setState({
            apiSortInfo: {sortColumn, sortDirection},
          }, () => {
            this.resetFilters();
            this.props.fetchReceiveHistoryByDate(this.state.FromDate, this.state.ToDate, this.state.Days, false, this.state.Type, this.state.currentPage, this.state.limit, this.state.PaymentStatus, this.getFilterParams());
          });
        } else {
          const state = Object.assign({}, this.state, { sortColumn, sortDirection });
          this.setState(state);
        }
      };

      const handleFilterChange = debounce((filter) => {
        this.setState({
          selectedRows: [],
        });
        const newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
        if (isOCM && false) {
          if (API_FILTERABLE_COLUMNS.includes(filter.column.key)) {
            handleOnPageChange({
              selected: 0
            });
          }
        }
      }, 500, { maxWait: 800 });

      // Handle the editable function
      const handleRowUpdated = (e) => {
        // merge updated row with current row and rerender by setting state
        const rows = this.state.rows.slice(0);
        const editedRows = this.state.editedRows.slice(0);
        Object.assign(rows[e.rowIdx], e.updated);
        // if the element is already edited, remove the old one.
        editedRows.forEach((element, index) => {
          if (element.Product_id === rows[e.rowIdx].Product_id) { editedRows.splice(index, 1); }
        }, this);
        // push the row into the editedRows array
        editedRows.push(rows[e.rowIdx]);
        this.setState({
          rows,
          editedRows,
        });
      };

      const DateFormatter = React.createClass({
        render() {
          if (this.props.value) {
            const date = new Date(this.props.value);
            return <span>{date.toString().slice(4, 15)}</span>;
          }
          return <span className="label label-danger">-</span>;
        },
      });

      const onRowClick = (rowIdx, row) => {
        if (row) {
          const rows = getRows();
          rows.map((r) => {
            r.isSelected = false;
          });
          const selectedRows = [rows[rowIdx]];
          rows[rowIdx].isSelected = true;
          // rows[rowIdx].isSelected = true;
          // setTimeout(() => {
            this.setState({
              WarehouseReceive_id: row.WarehouseReceive_id,
              rows: rows,
              selectedRows,
              // selectedRows,
            });
          // }, 1000);
          this.props.fetchReceiveHistoryDetailRecord(row.WarehouseReceive_id, row.Warehouse_ReceiveCompleted_id);
        }
      };
      const showReceivePrice = !checkPermission('no_show_product_cost');
      // Column difinition
      const columns = [
        ...!(isSH || isAP) && [{
          key: 'PONum',
          name: <Translate value="po_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }],
        ...(isUSPrideMulti || isGGI) ? [{
          key: 'container_num',
          name: <Translate value="container_no" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        }] : [],
        ...isGGI ? [{
          key: 'cso_num',
          name: <Translate value="cso_no" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 110,
        }] : [
          {
            key: 'WarehouseReceiveNum',
            name: <Translate value="receive_num" />,
            resizable: true,
            sortable: true,
            filterable: true,
            width: 110,
          }
        ],
        ...!(isSH || isAP) && [  {
          key: 'WarehouseName',
          name: <Translate value="warehouse" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
        }, {
          key: 'InvoiceNum',
          name: <Translate value="invoice_vendor" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
        }],
        {
          key: 'VendorName',
          name: <Translate value="vendor" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 200,
        },
        ...(isCPG || isVIP || isLMH || isBRO || isTQ || isGFD) ? [{
          key: 'SyncStatus',
          name: <Translate value="qb_sync" />,
          resizable: true,
          width: 90,
          sortable: true,
          filterable: true,
        }] : [],
        ...(isCPG || isVIP || isLMH || isBRO || isTQ || isGFD) ? [{
          key: 'QBError',
          name: <Translate value="qb_msg" />,
          resizable: true,
          width: 90,
          sortable: true,
          filterable: true,
        getRowMetaData: (row) => row,
          formatter: ({dependentValues}) => {
            return (
              <div style={{cursor: 'pointer'}} onClick={() => this.setState({syncModalVisibility: true, syncMsg: dependentValues.QBError})}>{(dependentValues.SyncStatus !== 'Synced') ? dependentValues.QBError : ''}</div>
            )
          }
        }] : [],
        ...(isSV || isSH || isAP) ? [{
          key: 'container_num',
          name: (isSH || isAP) ? <Translate value="container_no" /> : <Translate value="container" />,
          resizable: true,
          sortable: true,
          width: 110,
          filterable: true,
        }] : [],
        ...(!(isSH || isAP || isVAK) || isVAK && showReceivePrice) && [{
          key: 'PurchaseFinalPrice',
          name: <Translate value="po_final_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          formatter: CashFormatter,
        },
        {
          key: 'FinalPrice',
          name: <Translate value="receive_final_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          formatter: CashFormatter,
        },
        {
          key: 'InvoiceFinalPrice',
          name: <Translate value="invoice_final_dollarsign" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          formatter: CashFormatter,
        }],
        ...(isLAP || isUSPrideMulti || isAPD) && [{
          key: 'TotalWeight',
          name: <Translate value="total_wt" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
        },{
          key: 'TotalQty',
          name: <Translate value="total_qty" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
        }],
        ...!(isSH || isAP) && [
        {
          key: 'InvoiceStatus',
          name: <Translate value="invoice_status" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          formatter: ({ value }) => (
            <div>
              <Translate value={ value } />
            </div>
          ),
        }],
        {
          key: 'ArrivalStatus',
          name: <Translate value="arrival_status" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          formatter: ({ value }) => (
            <div>
              <Translate value={ value } />
            </div>
          ),
        },
        {
          key: 'PaymentStatus',
          name: <Translate value="payment_status" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
        },
        {
          key: 'PostingDate',
          name: <Translate value="receive_date" />,
          resizable: true,
          sortable: true,
          filterable: true,
          formatter: DateFormatter,
          width: 90,
        },
        {
          key: 'Create_Username',
          name: <Translate value="created_by" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        {
          key: 'Modify_Username',
          name: <Translate value="modify" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        },
        ...(isUSPrideMulti || isSV || isGGI || isSH || isAP) ? [] : [{
          key: 'container_num',
          name: <Translate value="container_no" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
        }],
        ...!(isSH || isAP) && [{
          key: 'Owner',
          name: <Translate value="owner" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        }],
        {
          key: 'Note',
          name: <Translate value="note" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        },
        ...(isSH || isAP) && [{
          key: 'CreateTime',
          name: <Translate value="created_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        }, {
          key: 'modify_datetime',
          name: <Translate value="modified_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        }]
      ];

      let totalAmount = 0.00;
      let totalOrders = 0;
      let totalVoidAmount = 0;
      let totalVoidOrders = 0;
      let totalWeight = 0.00;
      let totalVoidNetWeight = 0.00;
      let totalQty = 0;
      let totalVoidQty = 0;
      let selectedOrders = this.state.selectedRows.length;
      let limitSelection = [];
      if ((isLAP || isUSPrideMulti || isAPD)) {
        if (this.state.selectedRows && this.state.selectedRows.length > 0) {
          this.state.rows.map((r,i) => {
            if (r.PaymentStatus === "void") {
              totalVoidOrders++;
            } else {
              totalOrders++;
            }
          });
          this.state.selectedRows.map((r,i) => {
            if (r.PaymentStatus === "void") {
              totalVoidAmount += r.FinalPrice;
              totalVoidNetWeight += r.TotalWeight;
              totalVoidQty += r.TotalQty;
            } else {
              totalAmount += r.FinalPrice;
              totalWeight += r.TotalWeight;
              totalQty += r.TotalQty;
            }
          });
        } else {
          this.state.rows.map((r,i) => {
            if (r.PaymentStatus === "void") {
              totalVoidAmount += r.FinalPrice;
              totalVoidOrders++;
              totalVoidNetWeight += r.TotalWeight;
              totalVoidQty += r.TotalQty;
            } else {
              totalAmount += r.FinalPrice;
              totalOrders++;
              totalWeight += r.TotalWeight;
              totalQty += r.TotalQty;
            }
          });
        }
      } else {
        if (this.state.selectedRows && this.state.selectedRows.length > 0) {
          this.state.selectedRows.map((r,i) => {
            totalAmount += r.FinalPrice;
          });
          totalOrders = this.state.selectedRows.length;
        } else {
          if(((isLAP || isUSPrideMulti || isAPD) || isVAK) && this.state.rows && this.state.rows.length > 0) {
            this.state.rows.map((r,i) => {
              totalAmount += r.FinalPrice;
            });
          }
        }
        totalAmount = totalAmount.toFixed(2);
      }

      const handleLimitChange = (el) => {
        this.setState({
          limit: el.value,
          limitDisplay: el.label,
        }, () => {
          handleOnPageChange({
            selected: 0
          });
        })
      }
      const handleOnPageChange = (data) => {
        this.state.currentPage = data.selected;
        this.setState({
          selectedRows: [],
          rows: [],
        })
        this.resetFilters();
        this.props.fetchReceiveHistoryByDate(this.state.FromDate, this.state.ToDate, this.state.Days, false, this.state.Type, this.state.currentPage, this.state.limit, this.state.PaymentStatus, this.getFilterParams())
      }
      const showPagination = isOCM || isSH || isAP;
      let tableProps = {
        onRowSelect,
      };
      if (isOCM) {
        limitSelection = [{
          label: '30',
          value: 30,
          name: 'limit',
        }];
      } else if ( isSH || isAP ) {
        limitSelection = [{
          label: '10',
          value: 10,
          name: 'limit',
        }, {
          label: '20',
          value: 20,
          name: 'limit',
        }, {
          label: '50',
          value: 50,
          name: 'limit',
        },{
         label: '100',
         value: 100,
         name: 'limit',
        }];
      }

      let cTemp = [];
      if (this.state.rows && this.state.rows.length > 0) {
        this.state.rows.map((r,i) => {
          if (r.SyncStatus === 0) {
            cTemp.push({...r, SyncStatus: 'Unsynced'});
          } else if (r.SyncStatus === 1) {
            cTemp.push({...r, SyncStatus: 'Synced'});
          } else if (r.SyncStatus === 2) {
            cTemp.push({...r, SyncStatus: 'Failed'});
          } else {
            cTemp.push({...r});
          }
        });
        this.state.rows = cTemp;
      }
      const renderSummary = () => {
        if ((isLAP || isUSPrideMulti || isAPD)) {
          return (
            <Row>
              <Col xs={12}>
                <Col xs={4}>
                  <label style={{display: 'inline-flex', marginTop: '5px', fontSize: '12px'}}>
                  <span>
                    <Translate value="total_orders" />
                    :&nbsp;
                  </span>
                    <span className="font-color-orange" style={{marginLeft: '5px'}}>
                   {totalOrders + totalVoidOrders} - {totalVoidOrders} = {totalOrders}
                  </span>
                  </label>
                </Col>
                <Col xs={5}>
                  <label style={{display: 'inline-flex', marginTop: '5px', fontSize: '12px'}}>
                  <span>
                    <Translate value="total_received_final" />
                    :&nbsp;
                  </span>
                    <span className="font-color-grey" style={{marginLeft: '5px'}}>
                   {cashFormatter((totalAmount + totalVoidAmount).toFixed(2))} - {cashFormatter((totalVoidAmount).toFixed(2))} = {cashFormatter((totalAmount).toFixed(2))}
                  </span>
                  </label>
                </Col>
                <Col xs={3} valign="center">
                <span style={{display: 'inline-flex', marginTop: '5px', fontSize: '12px'}}>
                  <Translate value="msg_total_orders_equation" />
                </span>
                </Col>
              </Col>
              <Col xs={12}>
                <Col xs={4}>
                  <label style={{display: 'inline-flex', marginTop: '2px', fontSize: '12px'}}>
                  <span className="grand-total-label">
                    <Translate value="selected_orders" />
                    :&nbsp;
                  </span>
                    <span className="font-color-orange" style={{marginLeft: '5px'}}>
                    {selectedOrders}
                  </span>
                  </label>
                </Col>
                <Col xs={5}>
                  <label style={{display: 'inline-flex', marginTop: '5px', fontSize: '12px'}}>
                  <span>
                    <Translate value="total_received_wt" />
                    :&nbsp;
                  </span>
                    <span className="font-color-grey" style={{marginLeft: '5px'}}>
                   {(totalWeight + totalVoidNetWeight).toFixed(2)} - {(totalVoidNetWeight).toFixed(2)} = {(totalWeight).toFixed(2)}
                  </span>
                  </label>
                </Col>
                <Col xs={3}>
                <span style={{display: 'inline-flex', marginTop: '5px', fontSize: '12px'}}>
                  <Translate value="msg_received_total_equation" />
                </span>
                </Col>
              </Col>
              <Col xs={12}>
                <Col xs={4} />
                <Col xs={5}>
                  <label style={{display: 'inline-flex', marginTop: '5px', fontSize: '12px'}}>
                  <span>
                    <Translate value="total_received_qt" />
                    :&nbsp;
                  </span>
                    <span className="font-color-grey" style={{marginLeft: '5px'}}>
                   {totalQty + totalVoidQty} - {totalVoidQty} = {totalQty}
                  </span>
                  </label>
                </Col>
                <Col xs={3}>
                <span style={{display: 'inline-flex', marginTop: '5px', fontSize: '12px'}}>
                  <Translate value="msg_total_receive_weight_equation" />
                </span>
                </Col>
              </Col>
              <Col xs={12}>
                <Col xs={4} />
                <Col xs={5} />
                <Col xs={3}>
                  <span style={{display: 'inline-flex', marginTop: '5px', fontSize: '12px'}}>
                    <Translate value="msg_total_received_qty_equation" />
                  </span>
                </Col>
              </Col>
            </Row>
          )
        }
        return (
          <Row>
            <Col xs={12}>
              <label style={{display: 'inline-flex', marginTop: '5px', fontSize: '14px', marginLeft: '8px'}}>
              <span>
                <Translate value="total_received_final" />
                :&nbsp;
              </span>
                <span className="font-color-grey">
               ${totalAmount}
              </span>
              </label>
            </Col>
            <Col xs={12}>
              <label style={{display: 'inline-flex', marginTop: '2px', fontSize: '14px', marginLeft: '8px'}}>
              <span className="grand-total-label">
                <Translate value="selected_orders" />
                :&nbsp;
              </span>
                <span className="font-color-grey" id="total-equation">
                {totalOrders}
              </span>
              </label>
            </Col>
          </Row>
        )
      }
      return (
        <Row>
          <Col xs={12}>
            <div style={{ maxWidth: '99%' }} id="ReceiveHistoryList-dataGrid1">
              <ReactDataGrid
                rowKey="WarehouseReceive_id"
                ref={(g) => {
                  this.reactDataGridRef = g;
                }}
                enableCellSelect
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={ ((isSH || isAP) && getRows().length > 0) ? Math.min(getRows().length * 25 + 55) : 270}
                enableRowSelect="multi"
                onRowUpdated={handleRowUpdated}
                onRowClick={onRowClick}
                onRowSelect={onRowSelect}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
                onPageChange={handleOnPageChange}
                forcePage={this.state.currentPage}
                onClearFilters={this.resetFilters}
                {...tableProps}
              />
            </div>
          </Col>
          {
            showPagination &&
            <Row>
              <Col xs={6} style={{display: 'flex'}}>
                <div style={{ width: '600px' }} id="react-pagination">
                  <ReactPaginate
                    previousLabel={<Translate value="prev_page" />}
                    nextLabel={<Translate value="next_page" />}
                    containerClassName={'pagination'}
                    activeClassName={'active'}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    pageCount={this.props.totalPages}
                    onPageChange={handleOnPageChange}
                    forcePage={this.state.currentPage}
                  />
                </div>
                <div  style={{ width: '100px', marginTop: '6px', marginLeft: '15px'}}>
                  <Dropdown>
                    <Dropdown.Toggle style={{ height: '28px', width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                      {this.state.limitDisplay}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="super-colors">
                      {limitSelection.map(el => {
                        return (
                          <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                        )
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Col>
            </Row>
          }
          {renderSummary()}
        </Row>
      );
    }

    handleDownloadLabelClick = (WarehouseReceiveLine_id) => {
      const {
        WarehouseReceive_id,
      } = this.state;
      this.props.fetchLineLabel(WarehouseReceive_id, WarehouseReceiveLine_id);
    }

    renderDetailTable() {
      if (this.props.detailIsLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{this.props.error}</div></ContentWrapper>;

      // Parameters of the react-data-grid
      const getRows = () => Data.Selectors.getRows(this.state.receiveHistoryLine);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return Object.assign({}, rows[rowIdx]);
      };

      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        const state = Object.assign({}, this.state, { receiveHistoryLine: {...this.state.receiveHistoryLine, sortColumn, sortDirection }});
        this.setState(state);
      };

      const handleFilterChange = (filter) => {
        const newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
      };

      // Column difinition
      const IsFixedFormatter = React.createClass({
        render() {
          if (this.props.dependentValues.ProductType === 'Non-Fixed') {
            return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
          }
          return <span>{this.props.value}</span>;
        },
      });
      const LocationFormatter = connect(state => ({language: state.i18n.locale}))(React.createClass({
        render() {
          const {dependentValues, value, language} = this.props;
          return <span>{language === 'ch' ? dependentValues.zone_description : value}</span>
        }
      }))
      const showInventoryPrice = !checkPermission('no_show_product_cost');
      const columns = [
        ...isOLG ? [] : [{
          key: 'ProductNum',
          name: (isSH || isAP) ? <Translate value="sa_file_no" /> : <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        }],
        ...isOCM ? [{
          key: 'WarehouseReceiveLine_id',
          name: <Translate value="label" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            return <span style={{ cursor: 'pointer' }} onClick={
              // () => this.handleDownloadLabelClick(value);
              () => {
                const url = `https://ocm-scm.truckxi.com/api/v1/warehouse/receive/print_label/${dependentValues.WarehouseReceive_id}/${dependentValues.WarehouseReceiveLine_id}?Bearer=${localStorage.getItem('token')}`;
                window.open(url,'_blank')
              }
            }>download</span>
          },
        }] : [],
        {
          key: 'ProductRefNum',
          name: <Translate value={isOLG ? "item_no" : isVAK ? "sku" : "ref_num"} />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 70,
        },
        ...isAP ? [{
            key: 'Brand',
            name: <Translate value="brand" />,
            resizable: true,
            width: 80,
          }] : [{
          key: 'ProductName',
          name: <Translate value="prod_name" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 250,
        }],
        {
          key: 'ProductDescription',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 200,
        },
        ...(isSV) ? [{
          key: 'Barcode',
          name: <Translate value="barcode" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 150,
        }] : [],
        ...isGFD ? [{
          key: 'purchase_convert_unit',
          name: <Translate value="convert_num" />,
          resizable: true,
          sortable: true,
          width: 85,
          filterable: true
        },] : [],
        {
          key: 'PurchaseLine_Quantity',
          name: <Translate value={isGFD ? "order_case_qty" : "order_qty"} />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        },
        {
          key: 'RcvQuantity',
          name: <Translate value={isGFD ? "rcv_case_qty" : "rcv_qty"} />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: IsFixedFormatter,
          getRowMetaData: row => row,
        },
        ...isAP ? [{
            key: 'pkg_quantity',
            name: <Translate value='box' />,
            resizable: true,
            width: 60,
        },] : [],
        ...isGFD ? [{
          key: 'RcvUnitQuantity',
          name: <Translate value="rcv_unit_qty" />,
          resizable: true,
          sortable: true,
          width: 85,
          filterable: true
        },] : [],
        ...!(isSH || isAP) && [{
          key: 'RcvTotalWeight',
          name: <Translate value="receive_total_wt" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        }],
        ...isARC ? [{
          key: 'RcvUnitPrice',
          name: <Translate value="receive_unit_price" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            return <div style={{ width: '100%', textAlign:'center', backgroundColor: (dependentValues.last_cost < value) ? '#f6375d' : (dependentValues.last_cost > value) ? '#90ff90' : '' }}>{value}</div>
          },
          }] : [],
        ...(!(isVAK || isARC || isSW) || ((isVAK || isSW) && showInventoryPrice)) ? [{
          key: 'RcvUnitPrice',
          name: isGFD ? <Translate value="receive_cost_$" /> : <Translate value="receive_unit_price" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
          formatter: CashFormatter,
        }] : [],
        ...(!(isVAK || isSW) || ((isVAK|| isSW) && showInventoryPrice)) ? [{
          key: 'RcvTotalPrice',
          name: <Translate value="receive_total_price" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 120,
          formatter: CashFormatter,
        }] : [],
        ...isARC ? [{
            key: "last_cost",
            name: <Translate value="last_cost" />,
            resizable: true,
            width: 70,
            sortable: true,
          }] : [],
        ...(isVAK || isGFD) ? [] : [{
          key: 'Pallet',
          name: <Translate value="pallet" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 60,
        }],
        ...isVAK ? [] : [{
          key: 'Location',
          name: <Translate value="location" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 90,
        }],
        ...isAPD && [{
          key: 'lot_num',
          name: <Translate value="lot_no" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
        }],
        ...isGGI && [{
          key: "case_per_layer",
          name: <Translate value="case_per_layer" />,
          resizable: true,
          width: 120,
          sortable: true,
          editable: true,
        },
        {
          key: "layer_per_pallet",
          name: <Translate value="layer_per_pallet" />,
          resizable: true,
          width: 120,
          sortable: true,
          editable: true,
        }],
        ...isVAK ? [{
          name: <Translate value="qc_status"/>,
          resizable: true,
          width: 150,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => {
            if (dependentValues.DefectiveQuantity !== null && dependentValues.DefectiveQuantity !== undefined && dependentValues.DefectiveQuantity !== '') {
              return <div>{dependentValues.ExcellentQuantity + ' / ' + dependentValues.ConcessionQuantity + ' / ' + dependentValues.DefectiveQuantity}</div>
            }
            return <div />
          }
        }, {
          name: <Translate value="location" />,
          key: "zone_num",
          width: 120,
          getRowMetaData: row => row,
          formatter: LocationFormatter,
        }] : [{
          key: 'description',
          name: <Translate value="quality" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 150,
        }],
        {
          key: 'Remark',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 150,
        },
      ];

      if (isUSPrideMulti) {
        const index1 = _.findIndex(columns, { key: "RcvTotalWeight" });
        columns.splice(index1, 1);
        const index2 = _.findIndex(columns, { key: "Pallet" });
        const temp1 = {
          key: "PackageSize_1",
          name: <Translate value="volume_cft" />,
          resizable: true,
          width: 80,
          sortable: true,
        };
        columns.splice(index2, 0, temp1);
      }

      if (isABBLE) {
        const temp1 = {
          key: 'PurchaseLine_Quantity',
          name: <Translate value="order_ctn" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 60,
        };
        const temp2 = {
          key: 'RcvQuantity',
          name: <Translate value="rcv_pcs" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 80,
          formatter: IsFixedFormatter,
          getRowMetaData: row => row,
        };

        const PurchaseLineIndex = _.findIndex(columns, { key: "PurchaseLine_Quantity" });
        const RcvQuantityIndex = _.findIndex(columns, { key: "RcvQuantity" });
        columns.splice(PurchaseLineIndex, 1, temp1);
        columns.splice(RcvQuantityIndex, 1, temp2);
      }

      if (isMH) {
        const bundleBarcode = {
          key: 'bundle_barcode',
          name: <Translate value="bundle_barcode" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 200,
        };
        const PurchaseLineIndex = _.findIndex(columns, { key: "PurchaseLine_Quantity" });
        columns.splice(PurchaseLineIndex, 0, bundleBarcode);


      }

      const RowRenderer = React.createClass({
        getRowStyle: function() {
          return {
            color: this.getTextColor()
          }
        },
        getTextColor: function() {
          if (this.props.row.RcvQuantity > this.props.row.PurchaseLine_Quantity && isSV) {
            return 'red';
          } else {
            return null;
          }
        },
        render: function() {
          return (<div style={this.getRowStyle()}><ReactDataGrid.Row ref="row" {...this.props}/></div>)
        }
      });

      const onRowsSelected = (rows) => {
        const originalRows = getRows();
        _.forEach(rows, r => {
          originalRows[r.rowIdx].isSelected = true;
        });
        this.setState({
          receiveHistoryLine: {
            ...this.state.receiveHistoryLine,
            rows: originalRows,
          }
        })
      }
      const onRowsDeselected  = (rows) => {
        const originalRows = getRows();
        _.forEach(rows, r => {
          originalRows[r.rowIdx].isSelected = false;
        });
        this.setState({
          receiveHistoryLine: {
            ...this.state.receiveHistoryLine,
            rows: originalRows,
          }
        })
      }
      const renderProps = () => {
        if (isMH) {
          return {
            enableRowSelect: "single",
            rowSelection: {
              showCheckbox: true,
              onRowsSelected,
              onRowsDeselected,
              selectBy: {
                isSelectedKey: 'isSelected',
              },
            },
          }
        }
        return {}
      }

      return (
        <Row>
          {this.renderDetailButtons()}
          <Col xs={12}>
            <div style={{ maxWidth: '99%' }} id="ReceiveHistoryList-dataGrid2">
              <ReactDataGrid
                rowKey="WarehouseReceiveLine_id"
                ref={(g) => {
                  this.reactDataGridDetailRef = g;
                }}
                enableCellSelect
                onGridSort={handleGridSort}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={ ((isSH || isAP) && getRows().length > 0) ? Math.min(getRows().length * 25 + 55) : this.state.tableHeight / 2}
                {...renderProps()}
              />
            </div>
          </Col>
        </Row>
      );
    }

    renderDetailButtons = () => {
      if (isMH) {
        const selectedRows = Data.Selectors.getRows(this.state.receiveHistoryLine).filter(r => r.isSelected);
        const handlePrintBarcodeClick = () => {
          const pks = selectedRows.map(s => s.WarehouseReceiveLine_id);
          this.props.printBundleBarcode(pks.join(','));
        }
        return <Col xs={12}>
          <ButtonToolbar>
            <Button
              bsStyle="warning"
              type="button"
              disabled={!selectedRows.length}
              onClick={handlePrintBarcodeClick}
            >
              <em className="fa fa-print" /><Translate value="bundle_barcode" />
            </Button>
          </ButtonToolbar>
        </Col>
      }
    }

    renderIFrame() {
      if (this.props.warehouseReceivePdf) {
        const file = window.URL.createObjectURL(this.props.warehouseReceivePdf);
        return (
          <iframe style={{ display: 'none' }} onLoad={this.IFrameIsLoaded} id="Pdf" name="Pdf" src={file} />
        );
      }
    }

    renderPrint() {
      if (isSDR && !checkPermission('view_po_price')) return null;

      // default case where nothing is selected, causing button to be disabled
      let warehouseReceiveNums = null;

      // case where something is selected
      if (this.state.selectedRows) {
        if (this.state.selectedRows.length === 1) {
          warehouseReceiveNums = this.state.selectedRows[0].WarehouseReceiveNum;
        } else {
          const receivingNums = [];
          this.state.selectedRows.map((row) => {
            receivingNums.push(row.WarehouseReceiveNum);
          });
          warehouseReceiveNums = receivingNums.join(',');
        }
      }
      return (
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => {
            this.props.printWarehouseReceive(warehouseReceiveNums);
          }}
          disabled={!warehouseReceiveNums}
        >
          <em className="fa fa-print" /><Translate value="print" />
        </Button>
      );
    }

    renderSyncQB = () => {
      const { selectedRows } = this.state;
      const enabled = () => {
        if (checkPermission("set_released_sales_invoice") && selectedRows.length) {
          return true;
        }
        return false
      }
      const receive_ids = _.map(selectedRows, row => row.WarehouseReceive_id).join(',');
      return (
        <SpinnerButton
          bsStyle="primary"
          disabled={!enabled()}
          translation={<Translate value="sync_to_QB" />}
          loading={this.props.syncQbLoading}
          onClick={() => {
            this.props.syncReceiveHistoryToQuickBook(receive_ids);
          }}
        />
      )
    }

    renderExportDetailButton() {
      if (!isOCM && !isEKC && !isLMH && !isBRO && !isCRW && !isSC && !isSV && !isGGI || (isSDR && !checkPermission('view_po_price'))) return null;
      let { Days: days } = this.state;
      const { FromDate: f, ToDate: t, selectedRows } = this.state;
      days = days || 7;
      const { fromDate, toDate } = toFromDates(days, f, t);
      const token = localStorage.getItem('token');
      const ids = [];
      if (selectedRows.length) {
        _.forEach(selectedRows, ({ WarehouseReceive_id }) => {
          ids.push(WarehouseReceive_id);
        });
      };
      let data = '';
      if (ids.length) {
        data = `${ids.join(',')}?Bearer=${token}`
      } else {
        let params = `start_date=${fromDate}&end_date=${toDate}&warehouse_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}&company_id=${this.props.selectedCompany && this.props.selectedCompany.value}&Bearer=${token}`;
        data = `?${params}`
      }
      // const url = `${ROOT_URL}v1/warehouse/search/excel?${params}&Bearer=${token}`;

      const url = `${ROOT_URL}v1/warehouse/receive_history_export/${data}`;
      return (
        <Button
          bsStyle="success"
          type="button"
          href={url}
        >
          <em className="fa fa-download" />
          <Translate value="excel_line_details" />
        </Button>
      );
    }

    renderExcelButton() {
      if (isSDR && !checkPermission('view_po_price')) return null;

      let { Days: days } = this.state;
      const { FromDate: f, ToDate: t, selectedRows, Type, PaymentStatus } = this.state;
      days = days || 7;
      const { fromDate, toDate } = toFromDates(days, f, t);
      const token = localStorage.getItem('token');
      const i_ids = [];
      const p_ids = [];
      const ids = [];
      if (selectedRows.length) {
        _.forEach(selectedRows, ({ WarehouseReceive_id, PurchaseReturn_id }) => {
          if (isVAK || isGGI) {
            if(WarehouseReceive_id) i_ids.push(WarehouseReceive_id);
            if(PurchaseReturn_id) p_ids.push(PurchaseReturn_id)
          }else {
              ids.push(WarehouseReceive_id);
          }
        });
      };
      let data = [];
      data.push(`warehouse_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}`, `company_id=${this.props.selectedCompany && this.props.selectedCompany.value}`,`Bearer=${token}`)
      // let data = `&Bearer=${token}&warehouse_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}&company_id=${this.props.selectedCompany && this.props.selectedCompany.value}`
      // {{url}}v1/warehouse/search/excel?PostingDate__gte=2023-01-01T08:00:00.000Z&PostingDate__lte=2023-02-04T07:59:59.999Z&Report=false&warehouse_id=2&IsTransfer=false&IsRelocation=false
      data.push(`PostingDate__gte=${fromDate}`,`PostingDate__lte=${toDate}`);

      if(ids.length){
        data.push(`id=${ids.join(',')}`);
      }
      else{
        if (Type) {
          data.push(`Report=false`,`${Type}=true`)
        } else {
          if (isOCM) {
            data.push(`Report=false`,`IsRelocation=false`,`IsTransfer=false`)
          }
          if(isGGI) {
            data.push(`Report=false`)
          }
        }
        if (i_ids.length) {
          data.push(`i_ids=${i_ids.join(',')}`);
        }
        if (p_ids.length) {
          data.push(`p_ids=${p_ids.join(',')}`);
        }
        if (!i_ids.length && !p_ids.length) {
          data.push(`Report=true`)
        }

        if (PaymentStatus) {
          data.push(`PaymentStatus=${PaymentStatus}`);
        }
      }

      // const url = `${ROOT_URL}v1/warehouse/search/excel?${params}&Bearer=${token}`;
      let dataConcat = data.join("&")
      const url = `${ROOT_URL}v1/warehouse/search/excel?${dataConcat}`;
      return (
        <Button
          bsStyle="success"
          type="button"
          href={url}
        >
          <em className="fa fa-download" />
          <Translate value="excel" />
        </Button>
      );
    }

    renderPrintNs() {
      if (!isSDR) return null;
      const warehouseReceiveNums = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].WarehouseReceiveNum;

      const url = `${ROOT_URL}v1/warehouse/receive/print/no_price/${warehouseReceiveNums}`;
      return (
        <Button
          bsStyle="success"
          type="button"
          disabled={!warehouseReceiveNums}
          onClick={() => {
            this.props.printWarehouseReceiveNoSubtotals(warehouseReceiveNums);
          }}
        >
          <em className="fa fa-download" />
          <Translate value="print_ns" />
        </Button>
      );
    }

    handleMergePoSuccess = () => {
      this.setReceivedPOMergeModalVisibility();
      this.refreshList(true);
    }
    handleSplitPoSuccess = () => {
      this.setReceivedPOSplitModalVisibility();
      this.refreshList(true);
    }
    setReceivedPOMergeModalVisibility = (isReceivedPOMergeModalVisible = false) => this.setState({ isReceivedPOMergeModalVisible });
    setReceivedPOSplitModalVisibility = (isReceivedPOSplitModalVisible = false ) => this.setState({ isReceivedPOSplitModalVisible });

    renderMergeRecivedPOButton = () => {
      if (!isOCM) return null;
      const { rows, selectedRows } = this.state;
      return (
        <Button bsStyle="primary" disabled={selectedRows.length < 2} onClick={() => this.setReceivedPOMergeModalVisibility(true)}>
          {/* <em className="fa fa-merge" /> */}
          <Translate value="merge_received" />
        </Button>
      );
    }

    renderSplitRecivedPOButton = () => {
      if (!isOCM) return null;
      const { rows, selectedRows } = this.state;
      return (
        <Button bsStyle="primary" disabled={selectedRows.length !== 1} onClick={() => this.setReceivedPOSplitModalVisibility(true)}>
          {/* <em className="fa fa-merge" /> */}
          <Translate value="split_received" />
        </Button>
      );
    }

    renderExportLinesButton() {
      const token = localStorage.getItem('token');
      let warehouseIds = [];
      const { selectedRows } = this.state;
      if (selectedRows && selectedRows.length > 0) {
        selectedRows.map((row) => {
          warehouseIds.push(row.WarehouseReceive_id);
        });
      }
      const url = `${ROOT_URL}v1/warehouse/receive-lines-export/${warehouseIds.join(",")}?Bearer=${token}`;
      return (
        <Button
          bsStyle="success"
          type="button"
          href={url}
          disabled={(!warehouseIds || warehouseIds.length < 1)}
        >
          <em className="fa fa-download" />
          <Translate value="excel_lines" />
        </Button>
      );
    }

    setToRangeSearch = () => {
      this.setState({ Days: '-1' });
    }

    setFromDate = (e) => {
      if (e > this.state.ToDate) {
        return;
      }
      this.setState({ FromDate: e });
    }

    setToDate = (e) => {
      if (e < this.state.FromDate) {
        return;
      }
      this.setState({ ToDate: e });
    }

    checkEditable = () => {
      if (isVAK || isGGI) {
        return false;
      }
      const {
        selectedRows,
      } = this.state;
      if (selectedRows[0].InvoiceStatus === 'FINALIZED') {
        if (isOCM && checkPermission('set_released_sales_invoice')) {
          return false
        }
        return true
      }
      return false;
    }

    handleTypeFilterChange = (Type) => {
      this.setState({
        Type,
      }, () => {
        this.refreshList();
      })
    }

    handlePaymentStatusFilterChange = (PaymentStatus) => {
      this.setState({
        PaymentStatus,
      }, () => {
        this.refreshList();
      })
    }

    renderOrderTypeRadio = () => {
      if (!isOCM) return null;

      const config = {
        content: [
          {
            option: null,
            id: 'all-radio-filter',
            name: 'typeFilterRadios',
            labelName: 'normal',
          },
          {
            option: 'IsRelocation',
            id: 'placed-radio-filter',
            name: 'typeFilterRadios',
            labelName: 'relocated',
          },

        ],
        value: this.state.Type,
        handleOnClick: this.handleTypeFilterChange,
        type: 'buttons',
      }

      config.content.push({
        option: 'IsTransfer',
        id: 'transfer-radio-filter',
        name: 'typeFilterRadios',
        labelName: 'transfer',
      })

      return (
        <Row>
          <Col xs={1}>
            <h3 className="filter-title text-nowrap"><Translate value="order_type" /><span className="colon">:</span></h3>
          </Col>
          <Col xs={11}>
            {
              genericRadioFilter(config)
            }
          </Col>
        </Row>
      )
    }

    renderPaymentStatusRadio = () => {
      const config = {
        content: [
          {
            option: null,
            id: 'all-radio-filter',
            name: 'paymentFilterRadios',
            labelName: 'all',
          },
          {
            option: 'Open',
            id: 'open-radio-filter',
            name: 'paymentFilterRadios',
            labelName: 'open',
          },
          {
            option: 'Paid',
            id: 'paid-radio-filter',
            name: 'paymentFilterRadios',
            labelName: 'paid',
          },
          {
            option: 'Void',
            id: 'void-radio-filter',
            name: 'paymentFilterRadios',
            labelName: 'void',
          },
        ],
        value: this.state.PaymentStatus,
        handleOnClick: this.handlePaymentStatusFilterChange,
        type: 'buttons',
      }

      return (
        <Row>
          <Col xs={2}>
            <h3 className="filter-title text-nowrap"><Translate value="receiving_status" /><span className="colon">:</span></h3>
          </Col>
          <Col xs={10}>
            {
              genericRadioFilter(config)
            }
          </Col>
        </Row>
      )
    }

    render() {
      const createDialogStyle = {
        width: '600px',
        marginLeft: '-15%',
      };
      const createStatueStyle = {
        width: '400px',
        marginLeft: '-15%',
      };
      let warehouseReceive_id = this.state.selectedRows && this.state.selectedRows[0] && this.state.selectedRows[0].WarehouseReceive_id;
      warehouseReceive_id = warehouseReceive_id || '';

      const editRecPermission = (<Translate value="permission_for_deleting_a_receiving" />);
      const statusModal = (<Translate value="status" />);
      let voidStatus = this.props.voidStatus || '';
      let voidStatusEnd = '';
      let apNum = 0;
      if (voidStatus.includes('AP records existed for this warehouse receive (APNum: ')) {
        apNum = voidStatus.match(/\[(.*?)\]/)[0];
        const voidStatusAP = 'ap_records_existed_for_this_warehouse_receive_(apnum:_';
        voidStatusEnd = ')__action_denied_';
        voidStatus = voidStatusAP;
      }
      if (voidStatus && !apNum) {
        voidStatus = voidStatus.toLowerCase().replace(/\s/g, '_');
        voidStatus = voidStatus.replace(/\./g, '_');
        voidStatus = voidStatus.replace(/\'/g, '');
      }
      let disableVoid = !this.state.selectedRows || this.state.selectedRows.length !== 1 || !checkPermission('delete_receive');
      if (isVAK) {
        disableVoid = !this.state.selectedRows || this.state.selectedRows.length !== 1 || this.state.selectedRows[0].ArrivalStatus === 'void' || !checkPermission('delete_receive');
      }
      return (
      //---------------
      // Begin HTML
      //---------------
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="warehouse_management" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              <Translate value="receiving" />
            </Breadcrumb.Item>
          </Breadcrumb>
          <ButtonToolbar>
            {/* { this.renderExportButton() } */}
            { isTN && this.renderExportLinesButton() }
          </ButtonToolbar>

          <Grid id="receive-history-list">
            { /* Date Range Pickers */ }
            <Row>
              <Col xs={12}>
                <Panel id="date-range-picker" className="form-horizontal">
                  {this.renderOrderTypeRadio()}
                  <Row>
                    <Col xs={2}>
                      <h3 className="filter-title text-nowrap"><Translate value="receive_date" /><span className="colon">:</span></h3>
                    </Col>
                    <Col xs={10}>
                      {
                        dateFilterRadios({
                          handleOnClick: this.fetchReceiveHistoryByDetails,
                          setFromDate: this.setFromDate,
                          setToDate: this.setToDate,
                          setToRangeSearch: this.setToRangeSearch,
                          FromDate: this.state.FromDate,
                          ToDate: this.state.ToDate,
                          Days: this.state.Days,
                        })
                      }
                    </Col>
                  </Row>
                  { (isCPG || isVIP || isCCW) && this.renderPaymentStatusRadio() }
                </Panel>
              </Col>
            </Row>
            { /* End Date Range Pickers */ }

            <Row>
              <Col xs={12}>
                <Panel
                  className={`position-relative ${(isLAP || isUSPrideMulti || isAPD) ? 'table-collapse-fix-more' : 'table-collapse-fix'}`}
                  id={isOCM ? "table-collapse-fix-425" : (isSH || isAP) ? 'table-collapse-fix-auto' : ''}
                  >
                  <ButtonToolbar className="table-buttons">
                    <Button
                       bsStyle="warning"
                       type="button"
                       disabled={this.state.selectedRows.length !== 1 || !checkPermission('change_receive') || this.checkEditable()}
                       onClick={this.receiveDetail}
                    >
                      <em className="fa fa-pencil" /><Translate value="edit" />
                    </Button>
                    {
                      !(isSH || isAP) &&
                      <Button
                        bsStyle="warning"
                        type="button"
                        onClick={this.handleFinalizeClick}
                        disabled={!this.state.selectedRows.length || (isVAK && !checkPermission('finalize_rcv'))}
                      >
                        <em className="fa fa-pencil" /><Translate value={isVAK ? "receive_history_finalize" : "finalize"} />
                      </Button>
                    }
                    {/*
                      <Button
                      bsStyle="primary"
                      type="button"
                      onClick={this.autoPutaway}>
                      <em className="fa fa-plus" /><Translate value="auto_putaway" />
                      </Button>
                    */}
                    <Button
                      bsStyle="danger"
                      type="button"
                      onClick={this.openEditRecPermission}
                      onClick={() => {
                        if (isAPD) {
                          if (this.state.selectedRows[0].TSINum) {
                            alert('This is a dropship receiving, please update the original Sales Invoice ' + this.state.selectedRows[0].TSINum);
                          } else {
                            this.openEditRecPermission();
                          }
                        } else {
                          this.openEditRecPermission();
                        }
                      }}
                      disabled={disableVoid}
                    >
                      <em className="fa fa-trash" /><Translate value="void" />
                    </Button>
                    {this.renderPrint()}
                    {this.renderExportDetailButton()}
                    {this.renderExcelButton()}
                    {this.renderPrintNs()}
                    {this.renderMergeRecivedPOButton()}
                    {this.renderSplitRecivedPOButton()}
                    {this.renderSyncQB()}
                  </ButtonToolbar>
                  { this.renderTable() }
                </Panel>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <h2><Translate value="receive_details" /></h2>
                <Panel className="mb0">
                  { this.renderDetailTable() }
                </Panel>
              </Col>
            </Row>
          </Grid>
          {this.renderIFrame()}
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.syncModalVisibility}
            onCloseClicked={this.closeSyncVisibility}
          >
           <p style={{fontSize: '13px'}}>
              {this.state.syncMsg}
           </p>
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.editRecPermissionOpen} onCloseClicked={() => { this.closeEditRecPermission(); }} title={editRecPermission}>
            <ConfirmActionModal
              case={this.state.case}
              checkPermission={this.props.checkPermission}
              checkPermissionSuccess={this.props.checkPermissionSuccess}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createStatueStyle} isVisible={this.state.statusOpen} onCloseClicked={() => { this.closeStatusModal(); }} title={statusModal}>
            <ConfirmActionModal
              case={this.state.case}
              voidStatus={voidStatus}
              voidStatusEnd={voidStatusEnd}
              apNum={apNum}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createStatueStyle} isVisible={this.state.isFinalizeConfirmationModalVisible} onCloseClicked={() => { this.setFinalizeConfirmationModalVisibility(); }} title={<Translate value={isVAK ? "receive_history_finalize" : "finalize"} />}>
            <ConfirmActionModal
              case={this.state.case}
              onConfirm={this.handleFinalizeConfirm}
              onCancel={this.setFinalizeConfirmationModalVisibility}
            />
          </SkyLightStateless>
          <ReceivedPOMergeModal
            isVisible={this.state.isReceivedPOMergeModalVisible}
            onClose={this.setReceivedPOMergeModalVisibility}
            selectedRows={this.state.selectedRows}
            Company_id={this.props.selectedCompany && this.props.selectedCompany.value}
            handleMergePoSuccess={this.handleMergePoSuccess}
          />
          <ReceivedPOSplitModal
            isVisible={this.state.isReceivedPOSplitModalVisible}
            onClose={this.setReceivedPOSplitModalVisibility}
            selectedRows={this.state.selectedRows}
            handleSplitPoSuccess={this.handleSplitPoSuccess}
          />
        </ContentWrapper>
      //---------------
      // End HTML
      //---------------
      );
    }
}

export default ReceiveHistoryList;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/receiveHistoryList.jsx